module.exports = __webpack_public_path__ + "static/media/YF13_1.f9170d86.jpg";